import * as actionTypes from 'constants/actionTypes';

export const startTimer = (start) => ({
    type: actionTypes.START_TIMER,
    start
});
